import React, { ReactNode } from "react";
import CardLayout from "../layouts/Card";
import Typography from "../typography";

const Card = ({
  title,
  children,
  onClick,
  className,
}) => {
  return (
    <CardLayout>
      <div
        className={className || ""}
        onClick={(e) => {
          if (onClick) onClick();
        }}
      >
        <Typography text={title} variant="title" />

        {children}
      </div>
    </CardLayout>
  );
};

export default Card;
